/* Hello Saturday: responsive product gallery */
(function () {
  function initGallery(gallery) {
    if (gallery.dataset.hsReady) return;
    gallery.dataset.hsReady = 'true';
    const slides = Array.from(gallery.querySelectorAll('.hs-gallery__slides > .product__media-item'));
    const thumbs = Array.from(gallery.querySelectorAll('.hs-gallery__thumb'));
    const prev = gallery.querySelector('.hs-gallery__arrow--prev');
    const next = gallery.querySelector('.hs-gallery__arrow--next');
    const count = gallery.querySelector('.hs-gallery__count');
    let current = 0;
    function visibleSlides() { return slides.filter(s => !s.classList.contains('product__media-item--variant')); }
    function show(index) {
      const available = visibleSlides();
      if (!available.length) return;
      current = (index + available.length) % available.length;
      const selected = available[current];
      slides.forEach(s => s.classList.toggle('hs-gallery__active', s === selected));
      thumbs.forEach(t => t.setAttribute('aria-current', String(t.dataset.mediaId === selected.dataset.mediaId)));
      const activeThumb = thumbs.find(t => t.dataset.mediaId === selected.dataset.mediaId);
      if (activeThumb) activeThumb.scrollIntoView({block:'nearest',inline:'nearest'});
      if (count) count.textContent = `${current + 1} / ${available.length}`;
    }
    thumbs.forEach(t => t.addEventListener('click', () => {
      const index = visibleSlides().findIndex(s => s.dataset.mediaId === t.dataset.mediaId);
      if (index >= 0) show(index);
    }));
    if (prev) prev.addEventListener('click', () => show(current - 1));
    if (next) next.addEventListener('click', () => show(current + 1));
    let startX = null;
    const stage = gallery.querySelector('.hs-gallery__stage');
    stage.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, {passive:true});
    stage.addEventListener('touchend', e => {
      if (startX === null) return;
      const delta = e.changedTouches[0].clientX - startX;
      if (Math.abs(delta) > 45) show(current + (delta < 0 ? 1 : -1));
      startX = null;
    }, {passive:true});
    // Dawn updates the gallery when a variant with its own image is selected.
    document.addEventListener('variant:change', e => {
      const mediaId = e.detail?.variant?.featured_media?.id;
      if (!mediaId) return;
      const index = visibleSlides().findIndex(s => s.dataset.mediaId === `${gallery.dataset.sectionId}-${mediaId}`);
      if (index >= 0) show(index);
    });
    show(0);
  }
  function init() { document.querySelectorAll('.hs-gallery').forEach(initGallery); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
